<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dialogues">
<div class="section level2" id="seatcheck">
<h2>Seatcheck</h2>
<table style="width:98%;">
<colgroup>
<col width="5%"/>
<col width="83%"/>
</colgroup>
<thead>
<tr class="header">
<td align="left" colspan="2">M=man W=woman</td>
</tr>
</thead>
<tbody style="vertical-align: top;">
<tr class="odd">
<td align="left">W:</td>
<td>Did you do the laundry, dear?</td>
</tr>
<tr class="even">
<td align="left">M:</td>
<td>Yes, I did my love.</td>
</tr>
<tr class="odd">
<td align="left">W:</td>
<td>Did you mix the colors, sweetums?</td>
</tr>
<tr class="even">
<td align="left">M:</td>
<td>No, I didn’t my secret sweet.</td>
</tr>
<tr class="odd">
<td align="left">W:</td>
<td>Where are the car keys, my bear? Did you check the seat before we left?</td>
</tr>
<tr class="even">
<td align="left">M:</td>
<td>We would not be in this predicament if we were not talking about interracial laundry!</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?c06eb232